import { lazy, Suspense } from 'react'
import DashboardLayout from '../layouts/Dashboard'
import AuthGuard from '../components/guards/AuthGuard'
import LoadingState from '../components/LoadingState'

const MFA = lazy(() => import('../pages/pages/MFA'))
const MFASms = lazy(() => import('../pages/pages/MFASms'))
const MFAAuthenticator = lazy(() => import('../pages/pages/MFAAuthenticator'))

export default [
  {
    path: 'mfa',
    element: (
      <AuthGuard>
        <DashboardLayout>
          <Suspense fallback={<LoadingState align="center" />}>
            <MFA />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    )
  },
  // NOTE: Email MFA is disabled until we upgrade amazon-cognito-identity-js to amplify.
  // {
  //   path: 'mfa/email',
  //   element: (
  //     <AuthGuard>
  //       <DashboardLayout>
  //         <Suspense fallback={<LoadingState align="center" />}>
  //           <MFAEmail />
  //         </Suspense>
  //       </DashboardLayout>
  //     </AuthGuard>
  //   )
  // },
  {
    path: 'mfa/sms',
    element: (
      <AuthGuard>
        <DashboardLayout>
          <Suspense fallback={<LoadingState align="center" />}>
            <MFASms />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    )
  },
  {
    path: 'mfa/authenticator',
    element: (
      <AuthGuard>
        <DashboardLayout>
          <Suspense fallback={<LoadingState align="center" />}>
            <MFAAuthenticator />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    )
  }
]
